<template>
	<div class="bridge-wrapper">
		<!-- Content -->
		<div class="content">
			<template v-if="isUrlQueryValid">
				<strong>Redirecting...</strong>
				<br />
				<small>Please do not close this window</small>
				<br />
				<br />
				<strong>重新定向中…</strong>
				<br />
				<small>請不要關閉此視窗</small>
			</template>

			<!-- Show error -->
			<template v-else>
				<strong class="error-message">
					Oops, there was an error, some parameters are not valid.
					<br />
					噢，這裡出現了錯誤，某些參數不正確
				</strong>
			</template>
		</div>

		<!-- Based on provider render proper component -->
		<div class="form" v-if="isUrlQueryValid">
			<jetco-redirect v-if="provider === 'jetco'" :url="url" :token="token" />
		</div>
	</div>
</template>

<script>
import JetcoRedirect from "@/components/JetcoRedirect"

export default {
	components: {
		JetcoRedirect
	},

	computed: {
		/**
		 * We need to get provider, url and token from the URL
		 */
		provider() {
			return this.$route.query.provider ? this.$route.query.provider : null
		},

		url() {
			return this.$route.query.url ? this.$route.query.url : null
		},

		token() {
			return this.$route.query.token ? this.$route.query.token : null
		},

		/**
		 * This is checking whether we received all mandatory URL params
		 * and it's also checking if provider is correct
		 */
		isUrlQueryValid() {
			return (
				this.$route.query.provider &&
				this.$route.query.url &&
				this.$route.query.token &&
				this.provider === "jetco"
			)
		}
	}
}
</script>

<style scoped>
.content {
	padding-top: 50px;
}

.form {
	display: none;
}

.error-message {
	color: rgb(250, 50, 50);
}
</style>
